module.exports = __webpack_public_path__ + "static/media/survey-icon.54c72fd0.svg";